import tw, { styled, css } from 'twin.macro';

/*
 *  'min-w-0': Flex hack to have the class `break-words` to work in a flex environment.
 *  'break-words': Let the textual content break in a nice way
 */
export const ListItemContainer = styled.div(() => [
  tw`flex items-start break-words min-w-0`,
  css`
    & > p,
    & > div {
      ${tw`break-words min-w-0`}
    }
  `
]);

export const ListItemIcon = styled.div(() => [tw`my-2 mr-4 flex flex-shrink-0`]);
